/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTool(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M16.579 3.36a5.25 5.25 0 00-5.867 7.302.75.75 0 01-.153.84l-6.91 6.91a1.371 1.371 0 001.94 1.939l6.91-6.91a.75.75 0 01.84-.153 5.25 5.25 0 007.3-5.867l-2.915 2.916a1.75 1.75 0 01-2.45 0l-.005-.005-1.606-1.606a1.75 1.75 0 010-2.45l.005-.005 2.91-2.91zm-2.294-1.503a6.75 6.75 0 013.993.49.75.75 0 01.221 1.215l-3.766 3.766a.25.25 0 000 .346l1.593 1.593a.25.25 0 00.346 0l3.767-3.766a.75.75 0 011.213.221 6.75 6.75 0 01-8.444 9.13l-6.559 6.56a2.871 2.871 0 11-4.06-4.061l6.558-6.559a6.75 6.75 0 015.138-8.935z'
      />
    </svg>
  );
}

export default SvgTool;
